import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getLeavePolicy } from '../../services/leavePolicyService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import LeavePolicyVariationsTab from './tab-pages/LeavePolicyVariationsTab';
import LeavePolicyUsersTab from './tab-pages/LeavePolicyUsersTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  min-height: 0;
  padding-top: 8px;
  overflow-y: auto;

  /* Atama Kuralları sekmesi: tek kaydırma — kap taşmaz, yalnız tablo satırları kayar. */
  ${({ $fill }) => $fill && `
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `}
`;

export default function LeavePolicyDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [policy, setPolicy] = useState(null);
  const [activeTab, setActiveTab] = useState('variations');

  useEffect(() => {
    // api.js GET'te reddetmez: sinyal res.data.status.
    getLeavePolicy(id).then((res) => {
      if (res?.data?.status === true) setPolicy(res.data.data);
    });
  }, [id]);

  const tabs = [
    { key: 'variations', label: t('leavePolicy.tabVariations') },
    { key: 'rules', label: t('leavePolicy.assignmentRules') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('leavePolicy.title'), path: '/leave-policies' },
          { label: policy?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent $fill={activeTab === 'rules'}>
        {activeTab === 'variations' && <LeavePolicyVariationsTab policyId={id} />}
        {activeTab === 'rules' && <LeavePolicyUsersTab policyId={id} />}
      </TabContent>
    </PageContainer>
  );
}
